import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=cffda8f8&scoped=true&"
import script from "./BackButton.vue?vue&type=script&lang=ts&"
export * from "./BackButton.vue?vue&type=script&lang=ts&"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=cffda8f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffda8f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cffda8f8')) {
      api.createRecord('cffda8f8', component.options)
    } else {
      api.reload('cffda8f8', component.options)
    }
    module.hot.accept("./BackButton.vue?vue&type=template&id=cffda8f8&scoped=true&", function () {
      api.rerender('cffda8f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/BackButton.vue"
export default component.exports